// extracted by mini-css-extract-plugin
export default {"confirmUpdatesStepDataTableTitle":"confirmUpdatesStepDataTableTitle-T7_sj"};